module.exports = __webpack_public_path__ + "ae1c696bcd570e8231cb8c0cc1c26818.png";